import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-6 flex items-start justify-between" }
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = { class: "flex items-center gap-3 mb-2" }
const _hoisted_4 = { class: "flex flex-col items-end gap-2" }
const _hoisted_5 = { class: "space-y-6 pt-4" }
const _hoisted_6 = {
  key: 0,
  class: "space-y-3"
}
const _hoisted_7 = { class: "flex items-center gap-2" }
const _hoisted_8 = { class: "text-sm font-semibold text-gray-700" }
const _hoisted_9 = { class: "grid grid-cols-2 gap-2" }
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = { class: "text-sm text-purple-900 font-medium" }
const _hoisted_12 = { class: "grid grid-cols-2 md:grid-cols-3 gap-4" }
const _hoisted_13 = { class: "bg-cyan-50 border border-cyan-200 rounded-lg p-4" }
const _hoisted_14 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_15 = { class: "text-lg font-bold text-cyan-900" }
const _hoisted_16 = { class: "text-xs text-cyan-600 mt-1" }
const _hoisted_17 = { class: "bg-orange-50 border border-orange-200 rounded-lg p-4" }
const _hoisted_18 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_19 = { class: "text-lg font-bold text-orange-900" }
const _hoisted_20 = { class: "text-xs text-orange-600 mt-1" }
const _hoisted_21 = { class: "bg-indigo-50 border border-indigo-200 rounded-lg p-4" }
const _hoisted_22 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_23 = { class: "text-lg font-bold text-indigo-900" }
const _hoisted_24 = { class: "text-xs text-indigo-600 mt-1" }
const _hoisted_25 = { class: "bg-green-50 border border-green-200 rounded-lg p-4" }
const _hoisted_26 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_27 = { class: "text-3xl font-bold text-green-900" }
const _hoisted_28 = { class: "bg-blue-50 border border-blue-200 rounded-lg p-4" }
const _hoisted_29 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_30 = { class: "text-3xl font-bold text-blue-900" }
const _hoisted_31 = { class: "bg-pink-50 border border-pink-200 rounded-lg p-4" }
const _hoisted_32 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_33 = { class: "text-3xl font-bold text-pink-900" }
const _hoisted_34 = {
  key: 1,
  class: "space-y-3"
}
const _hoisted_35 = { class: "flex items-center justify-between" }
const _hoisted_36 = { class: "flex items-center gap-2" }
const _hoisted_37 = { class: "text-sm" }
const _hoisted_38 = { class: "grid grid-cols-1 md:grid-cols-2 gap-2 pt-4" }
const _hoisted_39 = { class: "text-sm text-gray-700" }
const _hoisted_40 = { class: "bg-gray-50 rounded-lg p-4 border border-gray-200" }
const _hoisted_41 = { class: "flex items-center gap-2 mb-4" }
const _hoisted_42 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_43 = { class: "space-y-3" }
const _hoisted_44 = { class: "text-sm font-mono text-gray-700 break-all bg-white p-2 rounded border border-gray-200" }
const _hoisted_45 = { class: "text-sm text-gray-700 bg-white p-2 rounded border border-gray-200" }
const _hoisted_46 = { class: "text-sm text-gray-700 bg-white p-2 rounded border border-gray-200" }
const _hoisted_47 = { class: "space-y-3" }
const _hoisted_48 = { class: "text-sm text-gray-700 bg-white p-2 rounded border border-gray-200" }
const _hoisted_49 = { class: "text-sm text-gray-700 bg-white p-2 rounded border border-gray-200" }
const _hoisted_50 = { class: "text-sm text-gray-700 bg-white p-2 rounded border border-gray-200" }
const _hoisted_51 = { class: "bg-blue-50 border border-blue-200 rounded-lg p-4" }
const _hoisted_52 = { class: "grid grid-cols-2 gap-4 text-sm" }
const _hoisted_53 = { class: "flex items-center gap-2" }
const _hoisted_54 = { class: "text-gray-700" }
const _hoisted_55 = { class: "flex items-center gap-2" }
const _hoisted_56 = { class: "text-gray-700" }
const _hoisted_57 = { class: "flex items-center gap-2" }
const _hoisted_58 = { class: "text-gray-700" }
const _hoisted_59 = { class: "flex items-center gap-2" }
const _hoisted_60 = { class: "text-gray-700" }

import { computed } from 'vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Badge } from '@/components/ui/badge'
import { Separator } from '@/components/ui/separator'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import {
  FileText,
  Users,
  Activity,
  Clock,
  Hash,
  Calendar,
  DollarSign,
  CheckCircle2,
  XCircle,
  Eye
} from 'lucide-vue-next'

interface TariffCodeItem {
  rate_id: string
  tariff_code: {
    id: number
    code: string
    code_description: string
    is_hbc: boolean
    benefit_type: Array<{
      id: number
      code: string
      code_description: string
    }>
    date_created: string
    date_modified: string
  }
  practice_type: Array<{
    code: string
    code_description: string
  }>
  billing_type: {
    code: string
    code_description: string
  }
  limit_type: {
    id: number
    code: string
    code_description: string
  }
  frequency: {
    id: number
    code: string
    code_description: string
  }
  applicable_year: number
  applicable_limits: number
  active: boolean
  date_created: string
  date_modified: string
}

interface Props {
  tariff: TariffCodeItem
  open?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TariffCodeDetailDialog',
  props: {
    tariff: {},
    open: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

// Format date
const formatDate = (dateStr: string) => {
  return new Date(dateStr).toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

// Get status color
const statusColor = computed(() => props.tariff.active ? 'text-green-600' : 'text-gray-500')
const statusBg = computed(() => props.tariff.active ? 'bg-green-50' : 'bg-gray-50')
const statusBorder = computed(() => props.tariff.active ? 'border-green-200' : 'border-gray-200')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    open: __props.open,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (emit('update:open', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogContent), { class: "bg-slate-100 w-[70vw] max-w-none sm:max-w-none overflow-y-auto" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(FileText), { class: "h-6 w-6 text-blue-600" }),
                    _createVNode(_unref(DialogTitle), { class: "text-2xl" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(__props.tariff.tariff_code.code), 1)
                      ]),
                      _: 1
                    }),
                    (__props.tariff.tariff_code.is_hbc)
                      ? (_openBlock(), _createBlock(_unref(Badge), {
                          key: 0,
                          variant: "default",
                          class: "ml-2"
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("HBC", -1)
                          ]))]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_unref(DialogDescription), { class: "text-base" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.tariff.tariff_code.code_description), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
                'flex items-center gap-2 px-3 py-1 rounded-full border',
                statusBg.value,
                statusBorder.value
              ])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['w-2 h-2 rounded-full', __props.tariff.active ? 'bg-green-500' : 'bg-gray-400'])
                    }, null, 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(['text-sm font-medium', statusColor.value])
                    }, _toDisplayString(__props.tariff.active ? 'Active' : 'Inactive'), 3)
                  ], 2),
                  _createVNode(_unref(Badge), {
                    variant: "secondary",
                    class: "text-lg font-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(__props.tariff.applicable_year), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(ScrollArea), { class: "h-[calc(90vh-200px)] pr-4" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                (__props.tariff.tariff_code.benefit_type?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_unref(Activity), { class: "h-5 w-5 text-purple-600" }),
                        _createElementVNode("h3", _hoisted_8, " Benefit Types (" + _toDisplayString(__props.tariff.tariff_code.benefit_type.length) + ") ", 1)
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tariff.tariff_code.benefit_type, (benefit) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: benefit.id,
                            class: "bg-purple-50 border border-purple-200 rounded-lg p-3"
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_unref(Badge), {
                                variant: "outline",
                                class: "font-mono bg-white"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(benefit.code), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(benefit.code_description), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(Separator)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_unref(DollarSign), { class: "h-4 w-4 text-cyan-600" }),
                      _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-xs font-semibold text-cyan-700" }, "Billing Type", -1))
                    ]),
                    _createElementVNode("p", _hoisted_15, _toDisplayString(__props.tariff.billing_type.code), 1),
                    _createElementVNode("p", _hoisted_16, _toDisplayString(__props.tariff.billing_type.code_description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_unref(Activity), { class: "h-4 w-4 text-orange-600" }),
                      _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-xs font-semibold text-orange-700" }, "Limit Type", -1))
                    ]),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(__props.tariff.limit_type.code), 1),
                    _createElementVNode("p", _hoisted_20, _toDisplayString(__props.tariff.limit_type.code_description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_unref(Clock), { class: "h-4 w-4 text-indigo-600" }),
                      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-xs font-semibold text-indigo-700" }, "Frequency", -1))
                    ]),
                    _createElementVNode("p", _hoisted_23, _toDisplayString(__props.tariff.frequency.code), 1),
                    _createElementVNode("p", _hoisted_24, _toDisplayString(__props.tariff.frequency.code_description), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createVNode(_unref(Hash), { class: "h-4 w-4 text-green-600" }),
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-xs font-semibold text-green-700" }, "Applicable Limits", -1))
                    ]),
                    _createElementVNode("p", _hoisted_27, _toDisplayString(__props.tariff.applicable_limits), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_unref(Hash), { class: "h-4 w-4 text-blue-600" }),
                      _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-xs font-semibold text-blue-700" }, "Tariff Code ID", -1))
                    ]),
                    _createElementVNode("p", _hoisted_30, _toDisplayString(__props.tariff.tariff_code.id), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_unref(Hash), { class: "h-4 w-4 text-pink-600" }),
                      _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-xs font-semibold text-pink-700" }, "Limit Type ID", -1))
                    ]),
                    _createElementVNode("p", _hoisted_33, _toDisplayString(__props.tariff.limit_type.id), 1)
                  ])
                ]),
                _createVNode(_unref(Separator)),
                (__props.tariff.practice_type?.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_unref(Users), { class: "h-5 w-5 text-gray-600" }),
                          _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-700" }, " Practice Types ", -1))
                        ]),
                        _createVNode(_unref(Badge), { variant: "secondary" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(__props.tariff.practice_type.length) + " types", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_unref(Accordion), {
                        type: "single",
                        collapsible: "",
                        class: "w-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(AccordionItem), { value: "practice-types" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(AccordionTrigger), { class: "hover:no-underline" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_37, "View all " + _toDisplayString(__props.tariff.practice_type.length) + " practice types", 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(AccordionContent), null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_38, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tariff.practice_type, (practice) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: practice.code,
                                        class: "flex items-center gap-2 bg-gray-50 p-3 rounded-lg border border-gray-200 hover:bg-gray-100 transition-colors"
                                      }, [
                                        _createVNode(_unref(Badge), {
                                          variant: "outline",
                                          class: "font-mono flex-shrink-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(practice.code), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(practice.code_description), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_unref(Separator)),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_unref(Calendar), { class: "h-5 w-5 text-gray-600" }),
                    _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-700" }, "Metadata & Timestamps", -1))
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-1" }, "Rate ID", -1)),
                        _createElementVNode("p", _hoisted_44, _toDisplayString(__props.tariff.rate_id), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-1" }, "Rate Created", -1)),
                        _createElementVNode("p", _hoisted_45, _toDisplayString(formatDate(__props.tariff.date_created)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-1" }, "Rate Modified", -1)),
                        _createElementVNode("p", _hoisted_46, _toDisplayString(formatDate(__props.tariff.date_modified)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-1" }, "Tariff Code Created", -1)),
                        _createElementVNode("p", _hoisted_48, _toDisplayString(formatDate(__props.tariff.tariff_code.date_created)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-1" }, "Tariff Code Modified", -1)),
                        _createElementVNode("p", _hoisted_49, _toDisplayString(formatDate(__props.tariff.tariff_code.date_modified)), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-gray-500 mb-1" }, "Frequency ID", -1)),
                        _createElementVNode("p", _hoisted_50, _toDisplayString(__props.tariff.frequency.id), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "text-sm font-semibold text-blue-900 mb-3" }, "Summary", -1)),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      (__props.tariff.active)
                        ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                            key: 0,
                            class: "h-4 w-4 text-green-600"
                          }))
                        : (_openBlock(), _createBlock(_unref(XCircle), {
                            key: 1,
                            class: "h-4 w-4 text-gray-400"
                          })),
                      _createElementVNode("span", _hoisted_54, [
                        _cache[16] || (_cache[16] = _createTextVNode(" Status: ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(__props.tariff.active ? 'Active' : 'Inactive'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      (__props.tariff.tariff_code.is_hbc)
                        ? (_openBlock(), _createBlock(_unref(CheckCircle2), {
                            key: 0,
                            class: "h-4 w-4 text-blue-600"
                          }))
                        : (_openBlock(), _createBlock(_unref(XCircle), {
                            key: 1,
                            class: "h-4 w-4 text-gray-400"
                          })),
                      _createElementVNode("span", _hoisted_56, [
                        _cache[17] || (_cache[17] = _createTextVNode(" HBC: ", -1)),
                        _createElementVNode("strong", null, _toDisplayString(__props.tariff.tariff_code.is_hbc ? 'Yes' : 'No'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createVNode(_unref(Activity), { class: "h-4 w-4 text-purple-600" }),
                      _createElementVNode("span", _hoisted_58, [
                        _createElementVNode("strong", null, _toDisplayString(__props.tariff.tariff_code.benefit_type.length), 1),
                        _cache[18] || (_cache[18] = _createTextVNode(" Benefit Types ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_unref(Users), { class: "h-4 w-4 text-gray-600" }),
                      _createElementVNode("span", _hoisted_60, [
                        _createElementVNode("strong", null, _toDisplayString(__props.tariff.practice_type.length), 1),
                        _cache[19] || (_cache[19] = _createTextVNode(" Practice Types ", -1))
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})